export default __webpack_public_path__ + "static/logo_eu-815de794121695dbc23bee17d3ea9d0a.png";